import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import _ from 'lodash'
import clsx from 'clsx'

const DarkMode = ({ children, darkModeEnabled }) => {
  return ( 
            <div className={clsx(darkModeEnabled ? 'bg-dark text-light' : '')}>
              {children}
            </div>
          )
}

DarkMode.propTypes = {
  children: PropTypes.node,
  darkModeEnabled: PropTypes.bool
}

const mapStateToProps = (state) => ({
  darkModeEnabled: state.general.darkModeEnabled
})

export default connect(mapStateToProps)(DarkMode);